import React from "react";
import  { useState, useEffect } from 'react';
import './classes/BaseballAgency.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";

const BaseballAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [baseballDirectors, setBaseballDirectors] = useState([]);
   const [agencyNews, setAgencyNews] = useState([]);

    useEffect(() => {

         const baseballDirectors = [
             {
                name: "Oscar Suarez",
                image: "/basic/web/images/agent/picture-1831-1441816596.jpg",
                link: "/agent/oscar-suarez",
                bio: ["MLB Agent"]
            }, 
            {
                name: "Dr Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/dr.-lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            }
        ];
        setBaseballDirectors(baseballDirectors);
        const agencyNews = [
  {
    img: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification"
  },
  {
    img: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    title: "SMWW Hockey Agency Director Michael Collier Earns PWHLP...",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification"
  },
  {
    img: "/basic/web/images/agent/Luquay_Washington.png",
    title: "SMWW Agency Welcomes New Athlete: Luquay Washington",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington"
  },
  {
    img: "/basic/web/images/agent/SMWW_Agency_Vincent_Demps.png",
    title: "Meet SMWW Agent Advisor J. Vincent Demps: From Military...",
    link: "/content/meet-smww-agent-advisor-j-vincent-demps-military-service-mastering-sports-representation"
  },
  {
    img: "/basic/web/images/agent/SMWW_Hockey_Agency.png",
    title: "SMWW Hockey Agency Director Michael Collier Secures Eur...",
    link: "/content/smww-hockey-agency-director-michael-collier-secures-european-pro-deal-aimee-o’neil-hammarby"
  }
];
setAgencyNews(agencyNews);
        
    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="baseball-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/baseball_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_baseball.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "28%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.8vw",
                fontWeight: "bold"
                }}
            >
                SMWW Baseball Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "2.24vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                representing baseball players throughout <br />
                the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="baseball-agency-main">
                <Helmet><title>SMWW Baseball Agency</title></Helmet>
                <div className="left baseball-agency-left">
                    <div className="view-content">
                    <h2>Baseball Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {baseballDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === baseballDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {baseballDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 ? "mob_sports_wrapper_odd" : "mob_sports_wrapper_even"}
                            style={{ float: index % 2 === 0 ? "left" : "right", width: "49%" }}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === baseballDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="baseball-agency-center">
                        <h1>SMWW Baseball Agency</h1>
                        <p><img className="imgfulli" src="/basic/web/images/agent/baseball.jpg"  style={{"float": "right", "marginLeft": "9px", "marginRight": "9px"}}/>Sports Management Worldwide Baseball is a full-service baseball agency with agents all over the world. We represent baseball players from the majors to the minors and in a variety of countries. Sports Management Worldwide has extensive connections and relationships in the world of baseball via our large network and unique alliances. SMWW's understanding of the game of baseball as well as our connections with executives throughout the major leagues, allow us to place clients in the best possible situation to help them succeed and reach their potential. SMWW has also developed relationships with baseball general managers, coaches, scouts and executives throughout the minor, independent and international leagues.</p>
                        <p>With over 15 years of industry experience, SMWW has a wide variety of resources and services to meet each individual client's needs. SMWW's agents and alliances work together to focus on maximizing the opportunities for our clients, both on and off the field, in the USA or globally. We are here to give a variety of advice, professional guidance, mentoring, and strategic counseling from a worldwide team of experienced professionals. Our athletes get the advantage of numerous professional opinions and a wealth of expertise of a large agency, yet the hands-on attention from an individual agent. We at Sports Management Worldwide think our clients deserve the best of both worlds; the best professional guidance available as well as the personal attention each athlete deserves. The SMWW personnel and consultants consist of former ballplayers, sabermetric gurus, ESPN analysts, professional MLB scouts, athletic trainers, coaches, top endorsement negotiators in the country and more importantly Agent Advisors.</p>
                        <p>When an athlete is evaluating potential agents to represent them, there are many choices. Sports Management Worldwide is here to guide you and help you make an informed decision that supports what is most important for your individual career. From contract negotiation to product endorsements, to travel arrangements, to athletic training, Sports Management Worldwide wants to be a step ahead of you and assist you with all your important decisions. A professional career can be short or long; either way, SMWW wants to help you make it as successful as possible and help an athlete prepare for their life after sports. At SMWW we make a "Field of Dreams" come true!</p>
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                If you are a baseball player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/baseball"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR BASEBALL AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                   <AgencySidebar/>
                   <h2>SMWW Sports Agency News</h2>
                   <div className="agency_blog">
      <ul className="list-unstyled mb-0">

        {agencyNews.map((post, index) => (
          <div key={index}>
            <li
              style={{
                listStyleType: "none",
                listStyle: "outside none"
              }}
            >
              <a href={post.link}>
                <img src={post.img} alt={post.title} />
              </a>

              <p className="stwwt-post-title">
                <a className="post-para" href={post.link}>
                  {post.title}
                </a>
                <br />
                <a href={post.link}>
                  <span className="button mr-1 arrow">Read Article</span>
                </a>
              </p>
            </li>

            {/* Separator */}
            {index < agencyNews.length - 1 && <li className="sepline">&nbsp;</li>}
          </div>
        ))}

      </ul>
    </div>

                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default BaseballAgency;